export default {
      id: "sli-upload-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#sli-upload",
      toString: function () {
        return this.url;
      }
    }